export default {
    init: function (utils) {
        this.initTeamMemberVisibility();
    },

    initTeamMemberVisibility: function () {
        // const teamMemberVisibilities = document.querySelectorAll('.js-team-member-visibility');
        // teamMemberVisibilities.forEach(function (teamMemberVisibility) {
        //     teamMemberVisibility.addEventListener('change', function () {
        //         console.log(this.value);
        //     });
        // });
    }
}